import {ModuleComponent} from "../../js/module-component";

export class ModFooter extends ModuleComponent{
    ready(){
        super.ready();

        this.findMember("block-item-a").click(
            (ev)=>{
                ev.preventDefault();
                const currentElement = $(ev.currentTarget);
                if(window.innerWidth<768){
                    const itemToUpdate = currentElement.siblings('.js-mod-footer__block-item-sub-items');
                    const isVisible = itemToUpdate.hasClass('is-subsections-show');

                    this.findMember("block-item-sub-items").removeClass('is-subsections-show');
                    this.findMember("block-item-a").removeClass('is-subsections-show');

                    if (!isVisible) {
                        itemToUpdate.addClass('is-subsections-show');
                        currentElement.addClass('is-subsections-show');
                    }
                }
            }
        );
    }
}
